// NOTE: Not currently in use but didn't want to delete the file so we can revive later
import { Locales } from '@ratehub/base-ui';

import createBlogAuthorStaticProps from '../functions/createBlogAuthorStaticProps';
import withFrenchLocale from '../functions/withFrenchLocale';
import BlogAuthorPage from '../components/BlogAuthorPage';


const { getStaticPaths, getStaticProps } = createBlogAuthorStaticProps({
    locale: Locales.FRENCH,
    fileName: 'blogAuthorFR',
    path: '/blogue/author',
});

export default withFrenchLocale(BlogAuthorPage);
export { getStaticPaths, getStaticProps };
